import React, {
  useState, useEffect
} from 'react';
import { connect } from 'dva';
import {
  Tabs
} from 'antd';
import { Input, Modal } from 'antd-mobile'
import { MTools } from '@/components';
import { RouteComponentProps, withRouter } from 'dva/router';
import { GlobalState } from '@/models/types';
import { getActivityList, giveLikeService, getActivityItem, getTopicList } from '@/services/api';
import zjl from '@/assets/image/mvideo/zjl.jpg';
// @ts-ignore
import Fingerprint2 from 'fingerprintjs2';

import praise1 from '@/assets/image/mvideo/praise1.png';
import praise2 from '@/assets/image/mvideo/praise2.png';
import praise3 from '@/assets/image/mvideo/praise3.png';
import praisePart from '@/assets/image/mvideo/praise-part.png';
import praiseOri from '@/assets/image/mvideo/praise-originality.png';
import searchIcon from '@/assets/image/mvideo/search.svg';
import footer from '@/assets/image/mvideo/footer.png';
import PraiseIcon from '@/assets/image/mvideo/praiseIcon.svg';


// import * as actions from '@/models/actions';

// import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import { IVipUserItem } from '@/routes/topic';
import styles from './index.less';

const { TabPane } = Tabs;

export interface IBbsDetail {
  id: string;
  cover: string;
  jobId: string;
  title: string;
  summary: string;
  sponsor: string;
  undertaker: string;
  activity: string;
  type: 1 | 2;
}

interface IBbsProps {
  vipUsers?: IVipUserItem[];
  list?: IBbsDetail[];
}


const microVideo: React.FC<IBbsProps & RouteComponentProps> = ({ match, vipUsers, list }) => {
  const [videoList, setVideoList] = useState<any>([]);
  const [searchValue, setSearchValue] = useState<any>('');
  const [videoPraiseList, setVideoPraiseList] = useState<any>([]);
  const [topicId, setTopicId] =  useState<any>('');
  useEffect(() => {
    getAllTopicList()
  }, []);

  const getAllTopicList = () => {
    getTopicList().then(res=>{
      const dataV = res.data.filter((item:any)=> item.title == '微视频大赛');
      setTopicId(dataV[0]?.id);
        getActivityList({ topicId: dataV[0]?.id }).then(res => {
        setVideoList(res.data.filter((item:any)=> item.type == 2));
        setVideoPraiseList(res.data.filter((item:any)=> item.type == 1))
      });
    })
  }

  // 获取浏览器的唯一标识符
  const createFingerprint = (id:any) => {
    // 浏览器指纹
      Fingerprint2.get((components: any) => {
      // 参数只有回调函数时，默认浏览器指纹依据所有配置信息进行生成
      const values = components.map((component: any) => component.value) // 配置的值的数组
      const murmur = Fingerprint2.x64hash128(values.join(''), 31) // 生成浏览器指纹
      // console.log(murmur,'浏览器唯一标识') 
      giveLike(id, murmur)
    })
  }

  const giveLike = (id:any, murmur: any ) => {
    giveLikeService(id, murmur).then((res:any)=>{
      if(res.success){
        MTools.Tips('success', '点赞成功');
        getTopicList().then(res=>{
          const dataV = res.data.filter((item:any)=> item.title == '微视频大赛');
          setTopicId(dataV[0]?.id);
            // 列表回显
            searchWorkItem();
        })
      } else {
        MTools.Tips('warning', res.message ? res.message : '您今天已点过赞，请明天再来')
      }
    })
  }

  const searchWorkItem = () => {
    getActivityItem({
      joinSearch:searchValue,
      topicId:topicId,
      type: 2
    }).then(res => {
      setVideoList(res.data)
    });
  }

  const OpenVideoModal = (url:any) => {
    Modal.alert({
      title: '带关闭图标的弹窗',
      content: <video src={url} controls/>,
      showCloseButton: true,
      closeOnMaskClick: true
    })
  }

  const RenderVideoBox = (props:any) => {
    const {item} = props
    return <div className={styles.videoBox}>
      <div className={styles.videoBoxCover} onClick={() => OpenVideoModal(item.url)}>
        <img src={item.cover}/>
      </div>
      <div className={styles.videoBoxTitle}>
        {item.title}
      </div>
      <div className={styles.videoBoxSpeaker}>
        {item.speaker}
      </div>
    </div>
  }

  return (
    <>
      <div className={styles.microVideoWrapper}>
        <div className={styles.microVideo}>
          <div className={styles.info}>
            <Tabs 
              type="card"
              tabBarGutter={11}
              defaultActiveKey={"2"}
            >
              <TabPane tab="征集令" key="1">
                <img className={styles.zjl} src={zjl} />
              </TabPane>
              <TabPane tab="作品展映" key="2">
                <div className={styles.worksWrapper}>
                  <div className={styles.searchBox}>
                    <div className={styles.searchIcon} onClick={searchWorkItem}>
                      <img src={searchIcon} />
                    </div> 
                    <Input
                      placeholder='搜索编号、作者、单位'
                      value={searchValue}
                      maxLength={20}
                      onChange={val => setSearchValue(val)}
                    />
                  </div>
                  <div className={styles.workList}>
                    {videoList.map((item:any, index:number) => (
                      <div key={index} className={styles.workItem}>
                        <div className={styles.title}>{item.title}</div>
                        <div className={styles.cover}>
                          <div onClick={() => OpenVideoModal(item.url)}>
                            <img className={styles.coverImg} src={item.cover}/>
                          </div>
                          <div className={styles.coverDes}>
                            <div>作者：<span>{item.speaker}</span></div>
                            <div>单位：<span>{item.enterpriseName}</span></div>
                            <div>作品编号：<span>{item.sortBy}号</span></div>
                            <div className={styles.praiseIconBox} onClick={() => createFingerprint(item.id)}>
                              <div>
                                <img src={PraiseIcon} />
                              </div>
                              <div className={styles.good}>
                                {item.good || 0} 票
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  {/* <InfiniteScroll loadMore={loadMore} hasMore={hasMore} /> */}
                </div>
              </TabPane>
              <TabPane tab="获奖名单" key="3">
                <div className={styles.praiseWrapper}>
                  <div className={styles.praiseTitle}>
                    <img src={praise1}></img>
                  </div>
                  {
                    videoPraiseList.filter((item:any) => item.praise == 1).map((item:any, index:number)=>{
                      return <div className={styles.praise1Box}>
                        <div className={styles.praiseVideoBox} onClick={() => OpenVideoModal(item.url)}>
                          <img src={item.cover}/>
                        </div>
                        <div className={styles.praise1Des}>
                          <div className={styles.title}>{item.title}</div>
                          <div className={styles.speaker}>{item.speaker}</div>
                        </div>
                      </div>
                    })
                  }
                  <div className={styles.praiseTitle}>
                    <img src={praise2}></img>
                  </div>
                  <div className={styles.videoBoxWrapper}>
                    {
                      videoPraiseList.filter((item:any) => item.praise == 2).map((item:any, index:number)=>{
                        return <RenderVideoBox key={index} item={item} />
                      })
                    }
                  </div>
                  <div className={styles.praiseTitle}>
                    <img src={praise3}></img>
                  </div>
                  <div className={styles.videoBoxWrapper}>
                    {
                      videoPraiseList.filter((item:any) => item.praise == 3).map((item:any, index:number)=>{
                        return <RenderVideoBox key={index} item={item} />
                      })
                    }
                  </div>
                  <div className={styles.praiseTitle}>
                    <img src={praiseOri}></img>
                  </div>
                  <div className={styles.videoBoxWrapper}>
                    {
                      videoPraiseList.filter((item:any) => item.praise == 4).map((item:any, index:number)=>{
                        return <RenderVideoBox key={index} item={item} />
                      })
                    }
                  </div>
                  <div className={styles.praiseTitle}>
                    <img src={praisePart}></img>
                  </div>
                  <div className={styles.videoBoxWrapper}>
                    {
                      videoPraiseList.filter((item:any) => item.praise == 5).map((item:any, index:number)=>{
                        return <RenderVideoBox key={index} item={item} />
                      })
                    }
                  </div>
                </div>
              </TabPane>
            </Tabs>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        <img className={styles.footerImg} src={footer}/>
      </div>
    </>
  );
};

const mapStateToProps = (state: GlobalState) => {
  return {
    list: state.subscription.bbs,
  };
};
export default connect(mapStateToProps)(withRouter(microVideo));
